import {customElement} from 'lit/decorators.js';
import {FlywheelComponent} from '#lit/lib/component.js';
import {ImmutableComponent} from '#lit/components/mixins/immutable_component/index.js';
import type {Constructor} from '#lit/types/classes.js';
import type {Model} from './architecture.js';
import {Msg, main} from './architecture.js';
import styles from './style.scss';
import {property} from 'lit-element';
import type {DatasetGroup} from '#lit/types/datasets.js';

export const DATASET_SELECTION_OPTIONS_ELEMENT_TAG =
  'dataset-selection-options';

@customElement(DATASET_SELECTION_OPTIONS_ELEMENT_TAG)
export default class DatasetSelectionOptions extends ImmutableComponent<
  Constructor<FlywheelComponent>,
  Model,
  Msg
>({component: FlywheelComponent, main}) {
  static get styles() {
    return [styles];
  }

  @property({type: Array})
  get datasetGroups(): DatasetGroup[] {
    return this.model.datasetGroups;
  }
  set datasetGroups(value: DatasetGroup[]) {
    this.handleUpdate(Msg.setDatasetGroups(value));
  }

  @property({type: String})
  get href(): string {
    return this.model.href;
  }
  set href(value: string) {
    this.handleUpdate(Msg.setHref(value));
  }

  @property({type: Boolean})
  get isAuthorizedForSourceConnections() {
    return this.model.isAuthorizedForSourceConnections;
  }

  set isAuthorizedForSourceConnections(value: boolean) {
    this.handleUpdate(Msg.setIsAuthorizedForSourceConnections(value));
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [DATASET_SELECTION_OPTIONS_ELEMENT_TAG]: DatasetSelectionOptions;
  }
}
